const ROUTE_CONSTANTS = {
  ROOT: '/',
};
export default ROUTE_CONSTANTS;
